import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Link from '@rad/components/utility/link';
import NavBadge from './nav-badge';
function NavLink(props) {
    const { item, isActive, showIcon = true, className, onClick } = props;
    return (_jsxs(Link, { href: item.href, "aria-current": isActive ? 'page' : undefined, className: `nav-link px-3 d-flex align-items-center gap-2${isActive ? ' fw-semibold active' : ''}${className ? ` ${className}` : ''}`, onClick: onClick, children: [showIcon && item.icon && _jsx("i", { className: `bi ${item.icon}` }), item.label, item.badge !== undefined && _jsx(NavBadge, { count: item.badge })] }));
}
export default NavLink;
